import React, { useCallback, useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getEyengageFilterCategories, getSelectedCategoriesFilter, getSelectedPostTypeFilter } from 'src/shared/redux-state/src/lib/eyengage/EyengageSelector';
import { useAppDispatch, useAppSelector } from 'src/app/services/store';
import { updateSelectedPostCategoryFilter, updateSelectedPostTypeFilter } from 'src/shared/redux-state/src/lib/eyengage/EyengageHandler';
import { updateEyengageFilterApplied } from 'src/shared/redux-state/src/lib/eyengage/EyengageHandler';
import { fetchEyengagePosts } from 'src/shared/redux-state/src/lib/eyengage/EyengageHandler';
import { getCurrentChild } from 'src/shared/redux-state/src/lib/login/LoginSelectors';
import { ChildrenStoreData, EyengageFilterCategory } from 'src/shared/types/src';
import { EngageFilterBody, EngageFilterFooter } from 'src/app/pages/eyengage/components/eyengageFilters';
import { isEqual, sortBy } from 'lodash';
import { CustomButton } from '../commonComponents';
import { EYENGAGE_URL_CONSTANTS } from 'src/app/config/appConstants';
import { getParamsFromQuery, getQueryString, encodeStringForQuery } from 'src/app/utilities/helpers';

type EyengageFilterModalProps = {
    isOpen: boolean,
    toggleModal: () => void,
}

const EyengageFilterModal: React.FC<EyengageFilterModalProps> = ({ isOpen, toggleModal }) => {

    const selectedTypeFilter = useAppSelector(getSelectedPostTypeFilter);
    const selectedCategories = useAppSelector(getSelectedCategoriesFilter);
    const filterCategories = useAppSelector(getEyengageFilterCategories);

    const dispatch = useAppDispatch();
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    const [postFilterType, setPostFilterType] = useState<Array<string>>([]);
    const [postFilterCategories, setPostFilterCategories] = useState<EyengageFilterCategory[]>([]);

    useEffect(() => {
        const params = getParamsFromQuery()
        const filterType = params?.get(EYENGAGE_URL_CONSTANTS.TYPE);
        const filterCategory = params?.get(EYENGAGE_URL_CONSTANTS.CATEGORIES);

        const filtersTypeArray = filterType?.split(',') || [];
        setPostFilterType(filtersTypeArray);

        const filtersCategoryArray = filterCategory?.split(',') || [];
        const filterCategoriesFromUrl = filterCategories.filter(val => filtersCategoryArray.includes(val.id.toString()));
        setPostFilterCategories(filterCategoriesFromUrl);
    }, [isOpen]);

    const applyEngageFilters = useCallback(async () => {
        const postType = postFilterType?.join(',');
        const categoryIds = postFilterCategories?.map((item) => item.id).join(',');

        dispatch(fetchEyengagePosts({ child: currentChild, page: 1, type: postType, categories: categoryIds }));

        if (postFilterType.length > 0 || postFilterCategories.length > 0) {
            dispatch(updateEyengageFilterApplied({ filterApplied: true }));
        } else {
            dispatch(updateEyengageFilterApplied({ filterApplied: false }));
        };

        dispatch(updateSelectedPostTypeFilter({ postFilter: postFilterType }));
        dispatch(updateSelectedPostCategoryFilter({ categoryFilter: postFilterCategories }));

        const query: string = getQueryString({postType, categoryIds})

        const q = encodeStringForQuery(query);
        if (!q) window.history.replaceState({}, '', window.location.pathname)
        else window.history.replaceState({}, '', `${window.location.pathname}?q=${q}`);

        window.scrollTo({ top: 0, behavior: 'smooth' });
        toggleModal();

    }, [currentChild, dispatch, postFilterType, postFilterCategories, toggleModal])

    const saveFilterTypeSelection = useCallback((data: any) => {
        if (isOpen) {
            setPostFilterType(data);
        }
    }, [isOpen]);

    const saveFilterTypeCategories = (categories?: EyengageFilterCategory[]) => {
        categories && setPostFilterCategories(categories);
    };

    return (
        <Modal 
            isOpen={isOpen} 
            toggle={toggleModal} 
            backdrop={true} 
            fade={false}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalBody className='mg-t-15'>
                <EngageFilterBody 
                    postFilterType={postFilterType}
                    postFilterCategories={postFilterCategories}
                    saveFilterTypeSelection={saveFilterTypeSelection}
                    saveFilterTypeCategories={saveFilterTypeCategories}
                />
            </ModalBody>
            <ModalFooter>
                <EngageFilterFooter applyEngageFilters={applyEngageFilters} />
            </ModalFooter>
        </Modal>
    )
}

export default EyengageFilterModal;